var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"0.25rem 0"}},[_c('div',{staticClass:"flex-items"},[_c('div',{staticClass:"tui-pillar"}),_c('div',{staticClass:"tui-headerTitle"},[_vm._v(_vm._s(_vm.Title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }